import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CoursePage from './pages/CoursePage';
import LevelExercisePage from './pages/LevelExercisePage';
import RedeemPage from './pages/RedeemPage';
import PdfCodigoPage from './pages/PdfCodigoPage';
import './App.css';

// La landing pública (marketing, temario, glosario y guías) es una app Astro
// independiente desplegada en cursoprogramacionbasica.es. Esta aplicación solo
// contiene el curso y vive en app.cursoprogramacionbasica.es.
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/curso" replace />} />
        <Route path="/curso" element={<CoursePage />} />
        <Route path="/level_exercise" element={<LevelExercisePage />} />
        <Route path="/redeem" element={<RedeemPage />} />
        <Route path="/pdfcodigo" element={<PdfCodigoPage />} />
        <Route path="*" element={<Navigate to="/curso" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
